/**
 * Hearst-specific playlist code, originally based on the
 * videojs-playlist plugin.
 *
 * This module doesn't export any functions; instead, importing
 * it has the side effect of registering the playlist plugin
 * with the VideoJS player.
 */
import videojs from 'video.js';
import playlistMaker from './playlistMaker';

/**
 * The video.js playlist plugin.
 *
 * @param {Array} sources - A list of sources.
 * @param {number} index - The index at which to start.
 */
function plugin(sources, index) {
  playlistMaker(this, sources, index);
}

videojs.registerPlugin('playlist', plugin);
